const TableIconCell = (props: any) => {
  return (
    <td onClick={props.handleClick} className="text-end">
      <span className="material-icons fs-4">{props.icon}</span>
    </td>
  );
};

export default TableIconCell;
